<template>
  <!-- 根据tableData的值去显示隐藏列表 -->
  <div style="height:100%">
    <div class="Main" v-if="!empty">
      <div class="topMain">
        <div slot="header" class="clearfix">
          <span>产品管理</span>
          <el-button v-if="multipleSelection.length == 0" style="float: right;" type="primary" @click="addBtn">创建
          </el-button>
          <div style="float: right;" v-if="multipleSelection.length != 0">
            <span>已选中<i class="checkedNumb"> {{ multipleSelection.length }}</i>
              个</span>
            <el-dropdown trigger="click" @command="operationBtn">
              <span class="el-dropdown-link">
                操作<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="{type:'del',para:multipleSelection}">删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

          </div>
        </div>
      </div>
      <div class="coreMain">
        <div>
          <el-input class="input-with-select" placeholder="搜索产品名称" v-model="search" @keyup.enter.native="searchBtn"
            maxlength="500">
          </el-input>
          <el-select v-model="accessPlatform" clearable placeholder="对接平台" @change="changeAccessPlatform">
            <el-option v-for="item in accessPlatformList" :key="item.value" :label="item.content" :value="item.value">
            </el-option>
          </el-select>
          <el-button @click="searchBtn" slot="append" icon="el-icon-search" type="primary"></el-button>
          <el-button class="clearSearch" type="text" @click="reset">清除搜索条件</el-button>
        </div>
        <el-table v-loading="loading" ref="multipleTable" :data="tableData" style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="产品名称" min-width="150px">
            <template slot-scope="scope">
              <el-link :underline="false" class="tableButton" type="primary" @click="detailBtn(scope.row.id)">
                {{ scope.row.name }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="commuType" label="通信类型" min-width="150px">
            <template slot-scope="scope">
              <span v-if="scope.row.commuType==1">TCP</span>
              <span v-else-if="scope.row.commuType==2">UDP</span>
              <span v-else-if="scope.row.commuType==3">MQTT</span>
              <span v-else-if="scope.row.commuType==4">HTTP</span>
              <span v-else-if="scope.row.commuType==5">COAP</span>
              <span v-else>---</span>
            </template>
          </el-table-column>
          <el-table-column prop="accessPlatform" label="对接平台" :formatter="getAccessPlatformLabel">
          </el-table-column>
          <el-table-column prop="moduleProtocolName" min-width="120px" label="网关协议">
            <template slot-scope="scope">
              <el-link :underline="false" class="tableButton" type="primary"
                @click="toModuleProtocolPage(scope.row.moduleProtocolId)">
                {{ scope.row.moduleProtocolName }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="deviceProtocolName" min-width="120px" label="设备协议">
            <template slot-scope="scope">
              <el-link :underline="false" class="tableButton" type="primary"
                @click="toDeviceProtocolPage(scope.row.deviceProtocolId)">
                {{ scope.row.deviceProtocolName }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="createDate" label="创建时间" :formatter="dateFormat" min-width="170px"></el-table-column>
          <el-table-column label="">
            <template slot-scope="scope">
              <el-dropdown class="briefDetails" style="top:22px;right:32px" @command="command">
                <span class="el-dropdown-link">
                  <i class="el-icon-more"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{ type: 'edit', row: scope.row }">编辑</el-dropdown-item>
                  <el-dropdown-item :command="{ type: 'del', row: scope.row }">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 没有网关显示的内容 -->
    <div class="emptyMain" v-if="empty">
      <el-card class="box-card">
        <img src="../../assets/images/shebeileijiankongdian.png" alt="" />
        <p>您还没有创建任何产品</p>
        <br />
        <el-button>了解详情</el-button>
        <el-button type="primary" @click="addBtn">创建产品</el-button>
      </el-card>
    </div>
  </div>
</template>

<script>
  import API from "../../api/api";
  import dayjs from "dayjs"
  export default {
    data() {
      return {
        maskVisible: false,
        empty: false, //控制数据为空展示空页面
        total: 0,
        pageSize: 10,
        currentPage: 1,
        loading: false, //加载条
        search: "", //搜索
        commuType: "", //状态
        accessPlatform: '', //对接平台
        accessPlatformList: [ //状态下拉数据
        ],
        tableData: [],
        multipleSelection: [],

      };
    },
    created() { },
    methods: {

      getAccessPlatformLabel(row) {
        let obj = this.accessPlatformList.filter(x => x.value == row.accessPlatform)
        if (obj[0]) return obj[0].content;
        return "--"
      },

      getAccessPlatformList() {

        API.getDictionaryListByCode({
          typeCode: "access_platform"
        }).then(res => {
          if (res.code === 1) {
            this.accessPlatformList = res.data.dictionaryList
          }
        })

      },

      toModuleProtocolPage(moduleProtocolId) {
        this.$router.push({
          path: "/device/moduleProtocolDetails",
          query: {
            id: moduleProtocolId
          }
        });
      },
      toDeviceProtocolPage(devProtocolId) {
        this.$router.push({
          path: "/equipment/equimentProtocolDetails",
          query: {
            id: devProtocolId
          }
        });
      },
      dateFormat(row, column, cellValue, index) {
        if (row.createDate) {
          return dayjs(new Date(row.createDate)).format("YYYY-MM-DD HH:mm:ss")
        } else {
          return '--'
        }
      },
      init() {
        this.getAccessPlatformList();
        this.getpageList();
      },
      //获取列表复用
      getpageList() {
        //获取列表数据
        let para = {
          accessPlatform: this.accessPlatform,
          commuType: this.commuType,
          search: this.search,
          pageSize: this.pageSize,
          currentPage: this.currentPage
        };
        this.loading = true; /*显示加载条*/
        API.platformProductPage(para)
          .then(res => {
            if (res.code == 1) {
              // if (res.data.resultPage.length == 0) {
              //   this.empty = true; //没有数据显示空页面
              // }
              this.tableData = res.data.resultPage;
              this.total = res.data.total;
            } else {
              this.$message.error(res.msg);
            }
            this.loading = false; /*显示加载条*/
          })

      },
      //输入搜索功能
      searchBtn() {
        this.currentPage = 1
        this.getpageList()
      },
      //对接平台下拉搜索
      changeAccessPlatform() {
        this.currentPage = 1
        this.getpageList()
      },
      //清除搜索条件
      reset() {
        this.search = "";
        this.currentPage = 1
        this.accessPlatform = ""
        this.getpageList()
      },
      //选中的数组
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      addBtn() {
        this.$router.push({
          path: "/product/productAdd",
          query: {
            flag: 'add'
          }
        })
      },
      //批量操作-删除
      operationBtn(val) {
        if (val.type == 'del') {
          let arr = []
          val.para.forEach(element => {
            arr.push(element.id)
          });
          let str = arr.join(',')
          this.delBtn(str)
        }
      },
      //单独删除
      command(val) {
        if (val.type == 'del') {
          let str = val.row.id
          this.delBtn(str)
        }
        if (val.type == 'edit') {
          this.$router.push({
            path: "/product/productAdd",
            query: {
              id: val.row.id,
              flag: 'edit'
            }
          });
        }
      },
      //删除功能 单独批量公用
      delBtn(delID) {
        this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          API.platformProductDelete(delID).then(res => {
            if (res.code == 1) {
              this.$message.success('删除成功');
              this.getpageList();
            } else {
              this.$message.error('删除失败');
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      //跳转到详情页
      detailBtn(id) {
        //  直接调用$router.push 实现携带参数的跳转
        this.$router.push({
          path: "/product/productDetail",
          query: {
            id: id
          }
        });
      },
      //分页
      handleSizeChange(val) {
        this.pageSize = val;
        this.currentPage = 1;
        this.getpageList()
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getpageList()
      }
    },
    mounted() {
      this.init()
    }
  };

</script>


// WEBPACK FOOTER //
// src/views/platform/productManagement.vue